import {
    FETCH_HOMEPAGE_LATEST_NEWS,
    HOMEPAGE_MAP_INFOGRAPHY,
    FETCH_SLIDER,
    FETCH_MARQUEE_NEWS,
    FETCH_HOMEPAGE_PARTNER_STORIES,
    FETCH_HOMEPAGE_HRRP_REFERENCE,
    FETCH_HOMEPAGE_RECENT_MINUTES
} from "../constants/actionType";

import {
    HOMEPAGE_LATEST_NEWS_API_URL,
    HOMEPAGE_MAP_INFOGRAPHY_API_URL,
    SLIDER_API_URL,
    MARQUEE_NEWS_API_URL,
    HOMEPAGE_PARTNER_STORIES_API_URL,
    HOMEPAGE_HRRP_REFERENCE_API_URL,
    HOMEPAGE_RECENT_MINUTES_API_URL
} from "../constants/urls";

function fetchHomePageLatestNews(url) {
    url = url && url.length > 0 ? url : HOMEPAGE_LATEST_NEWS_API_URL;
    if (url) {
        return {
            type: FETCH_HOMEPAGE_LATEST_NEWS,
            request: {
                url: url
            }
        };
    }
}

function fetchHomePageMapsInfography(url) {
    url = url && url.length > 0 ? url : HOMEPAGE_MAP_INFOGRAPHY_API_URL;
    if (url) {
        return {
            type: HOMEPAGE_MAP_INFOGRAPHY,
            request: {
                url: url
            }
        };
    }
}

function fetchSlider(url) {
    url = url && url.length > 0 ? url : SLIDER_API_URL;
    if (url) {
        return {
            type: FETCH_SLIDER,
            request: {
                url: url
            }
        };
    }
}

function fetchMarquee(url) {
    url = url && url.length > 0 ? url : MARQUEE_NEWS_API_URL;
    if (url) {
        return {
            type: FETCH_MARQUEE_NEWS,
            request: {
                url: url
            }
        };
    }
}

function fetchPartnerStories(url) {
    url = url && url.length > 0 ? url : HOMEPAGE_PARTNER_STORIES_API_URL;
    if (url) {
        return {
            type: FETCH_HOMEPAGE_PARTNER_STORIES,
            request: {
                url: url
            }
        };
    }
}

function fetchHomePageHrrpReferece(url) {
    url = url && url.length > 0 ? url : HOMEPAGE_HRRP_REFERENCE_API_URL;
    if (url) {
        return {
            type: FETCH_HOMEPAGE_HRRP_REFERENCE,
            request: {
                url: url
            }
        };
    }
}
function fetchHomePageRecentMinutes(url) {
    url = url && url.length > 0 ? url : HOMEPAGE_RECENT_MINUTES_API_URL;
    if (url) {
        return {
            type: FETCH_HOMEPAGE_RECENT_MINUTES,
            request: {
                url: url
            }
        };
    }
}

export {
    fetchHomePageLatestNews,
    fetchHomePageMapsInfography,
    fetchSlider,
    fetchMarquee,
    fetchPartnerStories,
    fetchHomePageHrrpReferece,
    fetchHomePageRecentMinutes
};